import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import AccountClientRequests from '@api/requests';

import type { MFAStateType } from './mfa.interfaces';

const initialState: MFAStateType = {
	mfaPreconditionData: null,
	availableMFAMethods: null,
	rememberMe: false,
};

export const { actions: mfaActions, reducer: mfaReducer } = createSlice({
	name: 'mfa',
	initialState,
	reducers: {
		setMFARequirements(state, { payload }: PayloadAction<Omit<MFAStateType, 'rememberMe'>>) {
			state.mfaPreconditionData = payload.mfaPreconditionData;
			state.availableMFAMethods = payload.availableMFAMethods;
		},
		setRememberMe(state, { payload }: PayloadAction<{ rememberMe: boolean }>) {
			state.rememberMe = payload?.rememberMe;
		},
		clearMFAPreconditionData(state) {
			state.mfaPreconditionData = initialState.mfaPreconditionData;
			state.availableMFAMethods = initialState.availableMFAMethods;
		},
	},
	extraReducers: builder => {
		builder
			.addCase(AccountClientRequests.Auth.login.fulfilled, state => {
				state.mfaPreconditionData = initialState.mfaPreconditionData;
				state.rememberMe = initialState.rememberMe;
				state.availableMFAMethods = initialState.availableMFAMethods;
			})
			.addCase(AccountClientRequests.Auth.logout.fulfilled, state => {
				state.mfaPreconditionData = initialState.mfaPreconditionData;
				state.rememberMe = initialState.rememberMe;
				state.availableMFAMethods = initialState.availableMFAMethods;
			});
	},
});
